"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class Clamp extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      noClamp: false,
      text: '.'
    };
    this.getEllipsis = () => !this.state.noClamp ? this.props.ellipsis : '';
    this.clampLines = () => {
      this.setState({
        text: ''
      });
      const maxHeight = this.lineHeight * this.props.lines + 1;
      this.start = 0;
      this.middle = 0;
      this.end = this.original.length;
      while (this.start <= this.end) {
        this.middle = Math.floor((this.start + this.end) / 2);
        this.element.innerText = this.original.slice(0, this.middle);
        if (this.middle === this.original.length) {
          this.setState({
            text: this.original,
            noClamp: true
          });
          return;
        }
        this.moveMarkers(maxHeight);
      }
      this.element.innerText = this.original.slice(0, this.middle - 5) + this.getEllipsis();
      this.setState({
        text: this.original.slice(0, this.middle - 5) + this.getEllipsis()
      });
      this.props.onClamp();
    };
    this.moveMarkers = maxHeight => {
      if (this.element.clientHeight <= maxHeight) {
        this.start = this.middle + 1;
      } else {
        this.end = this.middle - 1;
      }
    };
    this.element = null;
    this.original = props.text;
    this.lineHeight = 0;
    this.start = 0;
    this.middle = 0;
    this.end = 0;
  }
  componentDidMount() {
    if (this.props.text) {
      this.lineHeight = this.element.clientHeight + 1;
      this.clampLines();
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.text !== this.props.text) {
      this.original = this.props.text;
      this.clampLines();
    }
  }
  render() {
    const {
      text,
      className,
      onClamp,
      ...other
    } = this.props;
    if (!text) {
      return null;
    }
    return _react.default.createElement("div", (0, _extends2.default)({}, other, {
      className: className,
      ref: node => {
        this.element = node;
      }
    }), this.state.text);
  }
}
Clamp.defaultProps = {
  lines: 2,
  ellipsis: '…',
  onClamp: () => {}
};
var _default = exports.default = Clamp;